const CONST = require('plugin_frontend_core/constants');
const noUiSlider = require('nouislider');

const baseSearch = require('app_storefront_base/search/search');
const { replaceSpaceWithPeriod, debounce, isMediaBreakpoint } = require('plugin_frontend_core/utils/utils_cw');
const swiper = require('plugin_frontend_components/components/sliders');
const productTile = require('plugin_catalog/product/product-tile');

const selectors = {
    container: '.container',
    filterBar: '.filter-bar',
    gridFooter: '.grid-footer',
    gridHeader: '.grid-header',
    headerBar: '.header-bar',
    modalbackground: '.modal-background',
    pageTitle: '.header.page-title',
    productGrid: '.js-product-grid',
    productGridFooter: '.js-product-grid-footer',
    productTile: '.js-product-tile',
    productSort: '.js-product-sort',
    productResultCount: '.js-result-count',
    priceRefinement: '.js-price-refinement',
    refinedValues: '.js-refined-values',
    refinement: '.js-refinement',
    refinementBody: '.js-refinement-body',
    refinementButtonMobile: 'button.filter-results',
    refinementLinks: '.refinements li:not(.js-refinement-navigation-list-item-show-more-button), .refinement-bar .js-reset, .filter-value a, .swatch-filter a, .refinement-item, .js-quickrefinement-item',
    refinementModal: '.js-mobile-refinement-modal',
    refinementModalClose: '.js-refinement-modal-close',
    refinementModalCloseButton: 'button.close',
    refinementBarContainer: '.js-refinement-bar-container',
    refinementCategories: '.js-refinements-navigation',
    refinements: '.refinements',
    refinementsActive: '.refinement.active',
    refinementNavigationListItem: '.js-refinement-navigation-list-item',
    refinementNavigationListItemShowMoreButton: '.js-refinement-navigation-list-item-show-more-button',
    refinementNavigationShowMoreButton: '.js-refinement-navigation-show-more-button',
    refinementNavigationMoreButton: '.js-refinement-navigation-show-more-button',
    refinementPriceSlider: '.js-price-slider',
    refinementPriceSliderFromValue: '.js-price-slider-from-value',
    refinementPriceSliderToValue: '.js-price-slider-to-value',
    refinementPriceSliderTarget: '.noUI-target',
    refinementPriceSliderHandlerContainer: '.noUi-origin',
    refinementPriceSliderLowerHandler: '.noUi-handle-lower',
    refinementPriceSliderUpperHandler: '.noUi-handle-upper',
    contentSearchResults: '.js-content-search-results',
    showMoreContent: '.show-more-content',
    showMoreContentButton: '.show-more-content button',
    contentSearch: '.content-search',
    visibleOption: ':visible',
    resultCountVisible: '.result-count-visible',
    resultCount: '.result-count',
    filterActive: 'filter-active',
    quickRefinement: '.js-quickrefinement'
};

const attributes = {
    pageNumber: 'page-number',
    priceSliderMinValue: 'min',
    priceSliderMaxValue: 'max',
    priceSliderFromRange: 'from',
    priceSliderToRange: 'to',
    priceSliderUrl: 'url',
    refinementItem: 'data-refinement-item'
};

const $elements = {
    container: $(selectors.container),
    win: $(window),
    htmlBody: $(CONST.selectors.htmlBody),
    quickRefinements: $(selectors.quickRefinement)
};

const classes = {
    hidden: 'hidden'
};

const $document = $(document);

const $modalbackground = $(selectors.modalbackground);
const $refinementModal = $(selectors.refinementModal);

const $refinementNavigationShowMoreButton = $(selectors.refinementNavigationShowMoreButton);

const lockScroll = (isLock = false) => $elements.htmlBody[isLock ? 'addClass' : 'removeClass'](CONST.classes.scrollLock);

var $contentSearchResults = $(selectors.contentSearchResults);
var $pageContainer = $(selectors.container);

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    const $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Update filter options on request url
 * @param {string} requestedUrl -
 */
function updateUrl(requestedUrl) {
    if (!history.pushState) {
        return;
    }
    history.pushState({}, '', requestedUrl);
}

/**
 * Reset filters on popstate change
 */
window.addEventListener('popstate', () => {
    filterByUrl(location.href);
});

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $(selectors.refinementsActive).each((refinement) => {
        $(refinement).removeClass(CONST.classes.active);
        $results
            .find(`.${replaceSpaceWithPeriod($(refinement)[0].className)}`)
            .addClass(CONST.classes.active);
    });

    updateDom($results, selectors.refinements);
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    const $results = $(response);

    // Update DOM elements that do not require special handling
    const updateDomWithResults = (selector) => updateDom($results, selector);
    [
        selectors.gridHeader,
        selectors.headerBar,
        selectors.pageTitle,
        selectors.productGrid,
        selectors.showMoreButton,
        selectors.filterBar,
        selectors.refinementBarContainer,
        selectors.refinementCategories,
        selectors.refinementModalClose,
        selectors.productResultCount,
        selectors.refinedValues
    ].forEach(updateDomWithResults);

    // handle edge cases
    [
        {
            selector: selectors.refinements,
            handler: handleRefinements
        }
    ].forEach((special) => {
        special.handler($results);
    });
}

/**
 * Shows filter Modal
 */
function showFilterModal() {
    $modalbackground.show();
    $refinementModal.addClass(CONST.classes.show);
    $(CONST.selectors.body).addClass(selectors.filterActive);
    lockScroll(true);
}

/**
 * Hides filter Modal
 */
function hideFilterModal() {
    $modalbackground.hide();
    $refinementModal.removeClass(CONST.classes.show);
    $(CONST.selectors.body).removeClass(selectors.filterActive);
    lockScroll(false);
}

/**
 * Shows all hidden categories
 * @param {HTMLEvent} event - event
 */
function showAllRefinementCategories(event) {
    event.preventDefault();

    const $self = $(this);
    const $getChild = $self.closest(CONST.selectors.unOrderedListItem).children(CONST.selectors.listItem);

    if ($refinementNavigationShowMoreButton.length > 0) {
        $getChild.removeClass(classes.hidden);
        $getChild.children(selectors.refinementNavigationMoreButton).remove();
    }
}

/**
 * Renders the price slider handlers
 */
function setPriceSliderHandlers(lowerHandler, upperHandler) {
    const $lowerHandlerContainer = lowerHandler.closest(selectors.refinementPriceSliderHandlerContainer);
    lowerHandler.css({
        left: $lowerHandlerContainer.width(),
        opacity: 1
    });

    upperHandler.css({
        opacity: 1
    });
}

var filterByUrl; // Because es-lint

/**
 * Initialize sliders for prices
 */
function initPriceSlider() {
    var filterTimeout;

    $(`${selectors.refinementPriceSlider}:not(${selectors.refinementPriceSliderTarget})`).each(function () {
        const $priceSlider = $(this);
        let min = $priceSlider.data(attributes.priceSliderMinValue);
        let max = $priceSlider.data(attributes.priceSliderMaxValue);
        const from = $priceSlider.data(attributes.priceSliderFromRange);
        const to = $priceSlider.data(attributes.priceSliderToRange);
        const url = $priceSlider.data(attributes.priceSliderUrl);

        if (typeof min === 'string') {
            min = parseInt(min, 10);
        }
        if (typeof max === 'string') {
            max = parseInt(max, 10);
        }

        if (typeof min !== 'number' || typeof max !== 'number') {
            return;
        }

        const slider = noUiSlider.create($priceSlider[0], {
            connect: true,
            margin: 10,
            range: {
                min: min,
                max: max
            },
            start: [from, to],
            step: 1
        });

        function onSliderChange(values) {
            clearTimeout(filterTimeout);
            filterTimeout = setTimeout(function () {
                const pmin = values[0];
                const pmax = values[1];
                filterByUrl(url.replace('_PMIN_', Math.floor(pmin)).replace('_PMAX_', Math.ceil(pmax)));
            }, 1000);
        }
        slider.on(CONST.events.change, onSliderChange);

        slider.on(CONST.events.start, function () {
            clearTimeout(filterTimeout);
        });

        const $fromInput = $(selectors.refinementPriceSliderFromValue);
        const $toInput = $(selectors.refinementPriceSliderToValue);

        slider.on(CONST.events.update, function (values) {
            $fromInput.val(Math.floor(values[0]));
            $toInput.val(Math.ceil(values[1]));
        });

        $fromInput.on(CONST.events.change, function () {
            const parentSlider = $(this).closest('.js-refinement-body').find('.js-price-slider');
            parentSlider[0].noUiSlider.set([this.value, $toInput.val()]);
            onSliderChange([this.value, $toInput.val()]);
        });
        $toInput.on(CONST.events.change, function () {
            const parentSlider = $(this).closest('.js-refinement-body').find('.js-price-slider');
            parentSlider[0].noUiSlider.set([$fromInput.val(), this.value]);
            onSliderChange([$fromInput.val(), this.value]);
        });

        const $sliderTarget = $(slider.target);
        const $priceRefinement = $sliderTarget.closest(selectors.refinement);
        const $priceRefinementBody = $priceRefinement.find(selectors.refinementBody);
        const $priceRefinementLowerHandler = $sliderTarget.find(selectors.refinementPriceSliderLowerHandler);
        const $priceRefinementUpperHandler = $sliderTarget.find(selectors.refinementPriceSliderUpperHandler);

        if (min !== from || max !== to) {
            setPriceSliderHandlers(
                $priceRefinementLowerHandler,
                $priceRefinementUpperHandler
            );
        }

        $priceRefinementBody.on(CONST.events.bsCollapseShown, function () {
            setPriceSliderHandlers(
                $priceRefinementLowerHandler,
                $priceRefinementUpperHandler
            );
        });

        $refinementModal.on(CONST.events.bsModalShown, function () {
            $priceRefinementBody.on(CONST.events.bsCollapseShown, function () {
                setPriceSliderHandlers(
                    $priceRefinementLowerHandler,
                    $priceRefinementUpperHandler
                );
            });
        });
    });
}


/**
 * Starts spinner, updates dom with HTML returned from server
 * @todo update to async await once babel-pollyfill is added
 * @param {HTMLEvent} event -
 * @return {Promise<HTML|Object>} tends to call Search-UpdateGrid and return a block of html, this gets processed by parseResults
 */
function onApplyFilters(event) {
    event.preventDefault();
    event.stopPropagation();

    $.spinner().start();

    const { currentTarget } = event;
    const requestUrl = currentTarget.dataset[CONST.attributes.href];
    const page = $(selectors.gridFooter).data(attributes.pageNumber);
    const $htmlBody = $(CONST.selectors.htmlBody);

    $(currentTarget).trigger(CONST.events.searchFilter, event);

    // update to async await once babel-pollyfill is added
    return $.ajax({
        url: requestUrl,
        data: {
            page,
            selectedUrl: requestUrl
        },
        method: 'GET'
    }).then((results) => {
        parseResults(results);
        updateUrl(requestUrl);
        initPriceSlider();
        $htmlBody.animate({
            scrollTop: $htmlBody.offset().top
        }, {
            duration: CONST.times.scrollToAnimation,
            complete: function () {
                swiper.initProductTileSwiper();
                productTile.inViewPort();
            }
        });
        $('body').trigger('calculateWaardechequePrices');
        $.spinner().stop();
        return results;
    }).catch(() => {
        $.spinner().stop();
    });
}

/**
 * Starts spinner, updates dom with HTML returned from server
 * @param {*} event -
 */
function onApplySort(event) {
    event.preventDefault();
    const $self = $(this);
    const selectedIndex = $self.find('option:selected').index();
    $(selectors.productSort).each(function (i, el) {
        const option = $(el).children().eq(selectedIndex);
        if (option && option[0]) {
            option[0].selected = true;
        }
    });

    $.spinner().start();
    $self.trigger(CONST.events.searchSort, this.value);
    $.ajax({
        url: this.value,
        data: {
            selectedUrl: this.value
        },
        method: 'GET',
        success: function (response) {
            var newHtml = response;

            if ($(response).find(selectors.productGrid).length) {
                newHtml = $(response).find(selectors.productGrid)[0];
            }

            $(selectors.productGrid).empty().html(newHtml);
            swiper.initProductTileSwiper();
            productTile.inViewPort();

            var params = getUrlParams(this.url);
            if (params.srule) {
                var url = appendUrlParam(window.location.href, 'srule', params.srule);
                updateUrl(url);
            }
            $.spinner().stop();
        },
        error: function (error) {
            console.warn(`An error occured during sorting. Error: ${error}`); // eslint-disable-line
            $.spinner().stop();
        },
        complete: function () {
            $('body').trigger("calculateWaardechequePrices");
        }
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.attr('data-url');
    if (typeof showMoreUrl !== 'undefined') {
        $.spinner().start();
        $.ajax({
            url: showMoreUrl,
            method: 'GET',
            success: function (response) {
                $target.append(response);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            },
            complete: function () {
                $('body').trigger("calculateWaardechequePrices");
            }
        });
    }
}

/**
 * Handles plp resize events
 */
function onSearchResize() {
    if (!isMediaBreakpoint('md')) {
        return;
    }

    hideFilterModal();
}

/**
 * @private appendUrlParam
 * @param {string} url - The URL that needs an parameter assigned to
 * @param {string} key - The key of the parameter
 * @param {string} value - The value of the parameter
 *
 * @returns {string} url - A new url with the key & value appended.
 */
function appendUrlParam(url, key, value) {
    // return old URL if no key or value is passed
    if (!key || !value) {
        return url;
    }

    const formattedKey = `${key}=`;

    // Check if the new kew is already present in old url
    if (url.indexOf(formattedKey) !== -1) {
        var paramStartPoint = url.substr(url.indexOf(formattedKey), url.length);
        var paramEndPoint = '';

        if (paramStartPoint.indexOf('&') !== -1) {
            paramEndPoint = paramStartPoint.indexOf('&');
        } else {
            paramEndPoint = paramStartPoint.length;
        }

        // replace existing key with new value and return that url
        var paramValuePart = paramStartPoint.substr(0, paramEndPoint);
        return url.replace(paramValuePart, formattedKey + value);
    }

    // append the new parameter to the url
    var separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + formattedKey + encodeURIComponent(value);
}

/**
 * Extracts query string params from URL
 * @param {string} url - URL to get params of
 * @return {Object} params
 */
function getUrlParams(url) {
    var queryStringIndex = url.indexOf('?');
    if (queryStringIndex === -1) return {};

    var queryString = url.substring(queryStringIndex + 1);
    var params = {};
    queryString.split('&').forEach(function (part) {
        var subparts = part.split('=');
        var attr = decodeURIComponent(subparts[0]);
        var val = decodeURIComponent(subparts[1]);
        params[attr] = val;
    });
    return params;
}

/**
 * Apply filter by URL
 * @param {string} refinementUrl - Url of refinement filter
 */
filterByUrl = function (refinementUrl) {
    $.spinner().start();

    var url = refinementUrl;
    var currentParams = getUrlParams(window.location.href);
    if (currentParams.srule) {
        url = appendUrlParam(url, 'srule', currentParams.srule);
    }

    $.ajax({
        url: url,
        data: {
            page: $(selectors.productGridFooter).data(attributes.pageNumber),
            selectedUrl: url
        },
        method: 'GET',
        success: function (response) {
            $.spinner().stop();
            var currentUrl = $(response).find(selectors.currentURL);

            if (currentUrl.length > 0 && currentUrl.data(attributes.documentURL).length > 0) {
                url = currentUrl.data(attributes.documentURL);
            }

            history.replaceState({}, document.title, url);

            var $response = $(response);
            if ($response.find(selectors.productTile).length > 0) {
                parseResults(response);

                initPriceSlider();
                swiper.initProductTileSwiper();
            } else {
                updateDom($response, selectors.productGrid);
                updateDom($response, selectors.resultCountVisible);
            }
        },
        error: function () {
            $.spinner().stop();
        }
    });
};

module.exports = Object.assign(baseSearch, {
    resize() {
        $elements.win.on(CONST.events.resize, debounce(onSearchResize, 200));
    },
    filter() {
        $elements.container.on(CONST.events.click, selectors.refinementButtonMobile, showFilterModal);
        $elements.container.on(CONST.events.click, selectors.refinementModalClose, hideFilterModal);
    },
    closeRefinments() {
        $elements.container.on(CONST.events.click, selectors.refinementModalCloseButton, hideFilterModal);
    },
    applyFilter() {
        $elements.container.on(CONST.events.click, selectors.refinementLinks, onApplyFilters);
    },
    showMoreRefinements() {
        $document.on(CONST.events.click, selectors.refinementNavigationShowMoreButton, showAllRefinementCategories);
    },
    initPriceSlider() {
        $document.ready(initPriceSlider);
    },
    initQuickRefinement() {
        $document.ready(function () {
            // Only init if it exists, not sure if this is still in use?
            if ( $(selectors.quickRefinement).length ) {
                $elements.quickRefinements.slick({
                    infinite: false,
                    slidesToShow: 5,
                    variableWidth: true
                });
            }
        });
    },
    showContentTab: function () {
        // If there are no product results, only the content results are visible on page load
        if ($contentSearchResults.is(selectors.visibleOption) && $contentSearchResults.html() === '') {
            getContent($contentSearchResults, $contentSearchResults);
        }

        // Display content results from the search
        $pageContainer.on(CONST.events.click, selectors.contentSearch, function () {
            if ($contentSearchResults.html() === '') {
                getContent($contentSearchResults, $contentSearchResults);
            }
        });

        // Display the next page of content results from the search
        $pageContainer.on(CONST.events.click, selectors.showMoreContentButton, function () {
            const $self = $(this);
            getContent($self, $contentSearchResults.find(selectors.resultCount));
            $(selectors.showMoreContent).remove();
        });
    },
    sort: function () {
        $document.on(CONST.events.change, selectors.productSort, onApplySort);
    }
});
